import { HttpService } from 'app/services';
import * as AppActions from 'app/store/actions';
import { parseError } from 'helpers/Error';

export const GET_ANNOUNCEMENT_DETAIL = '@ANNOUNCEMENT/GET_DETAIL';
export const GET_ANNOUNCEMENT_DETAIL_SUCCESS = '@ANNOUNCEMENT/GET_DETAIL_SUCCESS';
export const GET_ANNOUNCEMENT_DETAIL_FAIL = '@ANNOUNCEMENT/GET_DETAIL_FAIL';

export const UPDATE_ANNOUNCEMENT = '@ANNOUNCEMENT/UPDATE';
export const UPDATE_ANNOUNCEMENT_SUCCESS = '@ANNOUNCEMENT/UPDATE_SUCCESS';
export const UPDATE_ANNOUNCEMENT_FAIL = '@ANNOUNCEMENT/UPDATE_FAIL';

export const CHANGE_ANNOUNCEMENT_UPDATE_FORM = '@ANNOUNCEMENT/CHANGE_UPDATE_FORM';
export const CLEAR_ANNOUNCEMENT_UPDATE_FORM = '@ANNOUNCEMENT/CLEAR_UPDATE_FORM';

const toAnnouncementPayload = (form) => ({
  title: form.title?.trim(),
  content: form.content,
  startDate: form.startDate,
  endDate: form.endDate,
  status: form.status,
});

export const getAnnouncementDetail = (id) => {
  return (dispatch) => {
    dispatch({ type: GET_ANNOUNCEMENT_DETAIL });
    return HttpService.get(`/api/announcements/${id}`)
      .then((resp) => {
        dispatch({
          type: GET_ANNOUNCEMENT_DETAIL_SUCCESS,
          payload: { data: resp.data },
        });
      })
      .catch((err) => {
        const { errorFields, errorMessages, errorTitle } = parseError(err);
        dispatch({
          type: GET_ANNOUNCEMENT_DETAIL_FAIL,
          payload: { message: errorMessages.join('\n'), error: errorFields },
        });
        dispatch(AppActions.createDialogMessage('error', errorTitle, errorMessages));
      });
  };
};

export const updateAnnouncement = (id) => {
  return (dispatch, getState) => {
    const { announcementForm } = getState().announcement.update;
    dispatch({ type: UPDATE_ANNOUNCEMENT });
    return HttpService.put(`/api/announcements/${id}`, toAnnouncementPayload(announcementForm))
      .then(() => {
        dispatch(AppActions.showMessage({ message: 'announcement:UPDATE_SUCCESS' }));
        dispatch({ type: UPDATE_ANNOUNCEMENT_SUCCESS });
        dispatch(AppActions.dataLoader_reload('GET:Announcements'));
      })
      .catch((err) => {
        const { errorFields, errorMessages, errorTitle } = parseError(err);
        dispatch({
          type: UPDATE_ANNOUNCEMENT_FAIL,
          payload: { message: errorMessages.join('\n'), error: errorFields },
        });
        dispatch(AppActions.createDialogMessage('error', errorTitle, errorMessages));
      });
  };
};

export const changeAnnouncementUpdateForm = (data) => ({
  type: CHANGE_ANNOUNCEMENT_UPDATE_FORM,
  payload: { data },
});

export const clearAnnouncementUpdateForm = () => ({
  type: CLEAR_ANNOUNCEMENT_UPDATE_FORM,
});
